import BrandingCharacter from "components/shared/BrandingCharacter";
import { useContext } from "react";
import { Context } from "Context";

const flyoutMainClass = "syndicated-flyout";
const primaryMainClass = `${flyoutMainClass}__primary`;
const secondaryMainClass = `${flyoutMainClass}__secondary`;

const getFlyoutClasses = (
	mainClass,
	{
		left = false,
		column = false,
		name = "",
		store = "",
		background = "",
		promosContainer = false,
		brand,
		isDecorative = false,
		collapse = false,
		showInMobile = false,
		reduceLayout,
	}
) => {
	let classes = mainClass;
	if (name) classes += ` ${mainClass}--${name}`;
	if (left) classes += ` ${mainClass}--left`;
	if (column) classes += ` ${mainClass}--column`;
	if (store) classes += ` ${mainClass}--store`;
	if (background) classes += ` ${mainClass}--${background}`;
	if (promosContainer) classes += ` ${mainClass}--promosContainer`;
	if (brand) classes += ` ${mainClass}--${brand}`;
	if (isDecorative) classes += ` ${mainClass}--decorative`;
	if (isDecorative && showInMobile) classes += ` ${mainClass}--show-in-mobile`;
	if (isDecorative && showInMobile && reduceLayout)
		classes += ` ${mainClass}--show-in-mobile--reduce-layout`;
	if (collapse) classes += ` ${mainClass}--collapse`;
	return classes;
};

const Flyout = ({
	left = false,
	column = false,
	name = "",
	store,
	children,
	collapse = false,
}) => {
	return (
		<div
			className={getFlyoutClasses(flyoutMainClass, {
				left,
				column,
				name,
				store,
				collapse,
			})}
		>
			{children}
		</div>
	);
};

const Primary = ({ children, image = {}, name = "", isMobileView = false }) => {
	const {
		config: { brand },
	} = useContext(Context);

	// Temporal while image is fully defined on the CMS
	return (
		<div className={getFlyoutClasses(primaryMainClass, { name, brand })}>
			{image?.url && !isMobileView && (
				<BrandingCharacter url={image?.url || undefined} />
			)}
			{children}
		</div>
	);
};

const Secondary = ({
	children,
	name = "",
	promosContainer = false,
	background = "",
	brand,
	isDecorative,
	showInMobile,
	reduceLayout,
}) => {
	return (
		<div
			className={getFlyoutClasses(secondaryMainClass, {
				background,
				name,
				promosContainer,
				brand,
				isDecorative,
				showInMobile,
				reduceLayout,
			})}
		>
			{children}
		</div>
	);
};

Flyout.Primary = Primary;
Flyout.Secondary = Secondary;
export default Flyout;
